<template>
  <div>
    <div v-if="img !=null">
      <img :src="img" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Imagem",

  props: {
    caminhoImagem: {
      type: String,
      required: true
    },
    nome: {
      type: String
    }
  },

  data() {
    return {
      img: null
    }
  },

  watch: {
    caminhoImagem(newValue) {
      this.fetchUrlFirebaseStorage(newValue)
    }
  },

  mounted() {
    this.fetchUrlFirebaseStorage(this.caminhoImagem);
  },

  methods: {
    async fetchUrlFirebaseStorage(refFromURL) {
      if (refFromURL != null) {
        await this.$firebase.storage()
          .refFromURL(refFromURL)
          .getDownloadURL()
          .then(url => {
            this.img = url;
          })
          .catch(function (err) {
            console.log("Erro Firebase (retornaUrlImagem)", err);
          });
      }
    }
  }
};
</script>

<style>
</style>